export default __webpack_public_path__ + "static/media/checkboxOff.d077eea9.svg";